import {
  Box,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Paper,
  Popper,
  Typography,
} from '@mui/material';
import axios from 'axios';
import { DispalyFileFormLink, OrderDetail } from 'Components/Orders/SageOrders/SageOrders';
import { mapStatusRegelement } from 'Components/Payment/AttachInvoicesPayment/constants';
import { format } from 'date-fns';
import React, {
  useCallback, useMemo, useRef, useState,
} from 'react';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import EnhancedTable from 'Shared/EnhancedTable';
import GlobalLoader from 'Shared/GlobalLoader/GlobalLoader';
import download from 'Images/download.svg';
import useOnClickOutside from 'Shared/Hooks/useClickOutSide';
import Filters from './Filters';
import { defaultMessage, downloadBL, getOrders } from '../PaymentServices';
import {
  columnsSAV, DOCUMENTS, mapOrderStatus,
} from './constants';
import useStyles from './style';
import useAppliedFilter from './useAppliedFilter';
import eye from './Icons/eye.svg';

let cancelToken;
const Orders = () => {
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [orders, setOrders] = useState({ content: [] });
  const [selectedRow, setSelectedRow] = useState(null);
  const [openDetail, setOpenDetail] = useState(false);
  const [order, setOrder] = useState(null);
  const [orderNumber, setOrderNumber] = useState(null);
  const [openDisplayFile, setOpenDisplayFile] = useState(false);
  const [fileLink, setFileLink] = useState(null);
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const actionRef = useRef();
  const {
    setValues, handleRefresh, values, appliedFilter, onHandleSubmitFilters,
  } = useAppliedFilter();
  const open = Boolean(anchorEl);
  useOnClickOutside(actionRef, () => setAnchorEl(null));
  const id = open ? 'transitions-popper' : undefined;
  const [arrowRef, setArrowRef] = React.useState(null);
  const handleInputChange = (prop) => (event, value) => {
    if (event?.toString() !== 'Invalid Date') {
      setValues((prev) => ({
        ...prev,
        [prop]: event instanceof Date ? event : value || event?.target.value,
      }));
    }
  };
  const getOrderList = useCallback(
    async (sort) => {
      try {
        setLoading(true);
        if (typeof cancelToken !== typeof undefined) {
          cancelToken.cancel('Cancel');
        }
        cancelToken = axios.CancelToken.source();
        let controlled;
        if (appliedFilter.controlled) {
          controlled = appliedFilter.controlled.value === 'CONTROLED';
        }
        const data = await getOrders(
          sort,
          {
            city: appliedFilter.city,
            controlled,
            zone: appliedFilter.zone,
            client: appliedFilter?.client?.map((c) => c.code),
            expedition: appliedFilter?.expedition?.map((c) => c.code),
            paymentMode: appliedFilter?.paymentMode?.map((c) => c.code),
            statusP: appliedFilter?.statusP?.value,
            commercial: appliedFilter.commercial?.map((c) => c.id),
            startDate: appliedFilter.startDate
              ? format(
                appliedFilter.startDate instanceof Date
                  ? appliedFilter.startDate : new Date(appliedFilter.startDate),
                'yyyy-MM-dd',
              )
              : undefined,
            endDate: appliedFilter.endDate
              ? format(
                appliedFilter.endDate instanceof Date
                  ? appliedFilter.endDate : new Date(appliedFilter.endDate),
                'yyyy-MM-dd',
              )
              : undefined,
            numCommande: appliedFilter.numCommande,
            numExpedition: appliedFilter.numExpedition,
            type: appliedFilter.type ? appliedFilter.type?.id : [],
            deposit: appliedFilter.deposit,
          },
          { cancelToken: cancelToken.token },
        );
        setOrders(data);
      } catch (e) {
        if (e.message !== 'Cancel') {
          const { response: { data: { statusLabel = defaultMessage } = {} } = {} } = e;
          toast.error(statusLabel);
        }
      } finally {
        setLoading(false);
      }
    },
    [setOrders, appliedFilter],
  );
  const handleSelectOrder = (o) => {
    setOrder(o);
    setOrderNumber(o.reference);

    setOpenDetail(true);
  };
  const getBL = useCallback(
    async (idf, bl, inTab = false) => {
      try {
        setLoading(true);
        await downloadBL(idf, bl, inTab);
      } catch (e) {
        const { response: { data: { statusLabel = defaultMessage } = {} } = {} } = e;
        toast.error(statusLabel);
      } finally {
        setLoading(false);
      }
    },
    [],
  );

  const handleDisplayExpedition = (link) => {
    setFileLink(link);
    setOpenDisplayFile(true);
  };

  const salesOrders = useMemo(
    () => orders.content.map((o, index) => ({
      ...o,
      id: index,
      amountTTC: o.details
        .reduce((prev, curr) => prev + curr.montantTtc, 0)
        ?.toFixed(2)
        .replace(/\d(?=(\d{3})+\.)/g, '$& '),
      amountHT: o.details
        .reduce(
          (prev, curr) => prev + (curr.prixUnitaire * curr.quantity * (100 - curr.remise)) / 100,
          0,
        )
        .toFixed(2)
        .replace(/\d(?=(\d{3})+\.)/g, '$& '),
      restAmount: (o.amount - o.paidAmount).toFixed(2),
      client: `${o.client?.code}: ${o.client?.name}`,
      paymentMode: o.paymentMode?.name,
      expedition: o.expedition?.name,
      expeditionNum: o.numExpedition,
      commercial: `${o.details[0]?.commercial?.firstName} ${o.details[0]?.commercial?.lastName}`,
      city: o.client?.city,
      noColor: true,
      // orange: o.quantityDifference || o.priceAndDiscountDifference,
      // red: o.falseReference,
      // greeen: o.paymentModeChange || o.expeditionModeChange || o.expeditionmodeChange,
      statusP: o.reglementStatus && mapStatusRegelement[o.reglementStatus]?.label,
      statusO:
        mapOrderStatus[o.status && o.status.status ? o.status.status : 'NON_ASSIGNEE']?.label,
      statusClass:
        classes[
          mapOrderStatus[o.status && o.status.status ? o.status.status : 'NON_ASSIGNEE'].class
        ],
      handleDetail: () => handleSelectOrder(o),
      handleDownloadBl: (bl) => (event) => {
        event.stopPropagation();
        getBL(o.reference, bl);
        setAnchorEl(null);
      },
      handleDisplayCoord1: (link) => (event) => {
        event.stopPropagation();
        handleDisplayExpedition(link);
        setAnchorEl(null);
      },
      handleEdit: (order_) => (event) => {
        event.stopPropagation();
        const orderEdit = {
          reference: order_.reference,
          commercial: {
            ...order_.details[0].commercial,
            name: `${order_.details[0].commercial.firstName} ${order_.details[0].commercial.lastName}`,
          },
          packageNumber: order_.colisage,
          expedition: order_.expedition,
          paymentMode: { name: order_.paymentMode },
          declarationNum: order_.numExpedition,
          packedBy: '',
        };
        history.push('/controle-orders/edit', orderEdit);
        setAnchorEl(null);
      },
      openPopOver: (row) => (event) => {
        event?.stopPropagation();
        setAnchorEl(anchorEl ? null : event.currentTarget);
        setSelectedRow(row);
      },
    })),
    [orders, handleDisplayExpedition, handleSelectOrder, handleSelectOrder],
  );

  return (
    <Box sx={{ padding: '38px 16px 25px 25px' }}>
      {loading && <GlobalLoader size="100vh" />}
      <Box sx={{ display: 'flex', mb: 2, justifyContent: 'space-between' }}>
        <Typography sx={{
          font: 'normal normal 600 30px Montserrat',
          color: '#000000',
        }}
        >
          Liste De Documents De Vente
        </Typography>
      </Box>
      <Popper
        id={id}
        open={open}
        ref={actionRef}
        anchorEl={anchorEl}
        placement="bottom-end"
        className={classes.popper}
        disablePortal={false}
        modifiers={{
          flip: {
            enabled: true,
          },
          preventOverflow: {
            enabled: true,
            boundariesElement: 'scrollParent',
          },
          arrow: {
            enabled: true,
            element: arrowRef,
          },
        }}
      >
        {false && <span className={classes.arrow} ref={setArrowRef} />}
        <Paper
          className={{
            maxWidth: 400,
            overflow: 'auto',
            background: '#FFFFFF 0% 0% no-repeat padding-box',
            boxShadow: '0px 12px 26px #0000001C',
            border: '1px solid #F7F7F7',
          }}
        >
          <List component="nav" aria-labelledby="nested-list-subheader" className={classes.root}>
            <ListItem
              button
              onClick={selectedRow?.handleDetail}
            >
              <ListItemIcon sx={{ minWidth: '28px' }}>
                <img src={eye} alt="Eye" width="18" height="18" />
              </ListItemIcon>
              <ListItemText
                primary={(
                  <Typography
                    style={{ color: '#38485C', font: 'normal normal 600 16px Montserrat' }}
                  >
                    Voir Le Document
                  </Typography>
                )}
              />
            </ListItem>
            {DOCUMENTS[selectedRow?.type] && (
              <ListItem
                button
                onClick={selectedRow?.handleDownloadBl([3, 4].includes(selectedRow?.type))}
              >
                <ListItemIcon sx={{ minWidth: '28px' }}>
                  <img src={download} alt="Download" width="18" height="18" />
                </ListItemIcon>
                <ListItemText
                  primary={(
                    <Typography
                      style={{ color: '#38485C', font: 'normal normal 600 16px Montserrat' }}
                    >
                      Télecharger le document
                    </Typography>
                  )}
                />
              </ListItem>
            )}
          </List>
        </Paper>
      </Popper>
      <Box
        style={{
          display: 'flex',
          padding: 10,
          alignItems: 'center',
          background: '#E9EBED 0% 0% no-repeat padding-box',
          bordeRradius: '0px 0px 12px 12px',
          opacity: 1,
          marginBottom: 16,
          borderRadius: '12px',
        }}
      >
        <Filters
          values={values}
          handleInputChange={handleInputChange}
          product
          handleRefresh={handleRefresh}
          onSubmitSearch={onHandleSubmitFilters}
        />
      </Box>
      <OrderDetail
        orderNumber={orderNumber}
        open={openDetail}
        setOpen={setOpenDetail}
        order={order}
        printBC={getBL}
      />
      <DispalyFileFormLink link={fileLink} open={openDisplayFile} setOpen={setOpenDisplayFile} />
      <EnhancedTable
        getData={getOrderList}
        rows={salesOrders}
        headCells={columnsSAV}
        count={orders.totalElements}
        resetSort={appliedFilter}
        rowsPerPageOptions={[10, 15, 20]}
      />
    </Box>
  );
};

export default Orders;
